// extracted by mini-css-extract-plugin
module.exports = {"disabled":"Switch_disabled__dkuj8","container":"Switch_container__avQG_"};